module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-weapon14.png?b1ddd4f2";